module.exports = __webpack_public_path__ + "static/media/6.c780ea0f.png";